import React, { useState, useEffect, useRef } from "react";
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { Link } from 'react-router-dom';
import DeliveriesBoys from './DeliveriesBoys';

function Addbikestransfer({ setShowForm, selectedBoy, refreshManagers }) {
    const [loading, setLoading] = useState(false);
    const [leads, setLeads] = useState([]);
    const [deliveryBoys, setdeliveryBoys] = useState([]);
    const [workshopaddress, setworkshopaddress] = useState([]);

    const [formData, setFormData] = useState({
        id: selectedBoy?.id || null,
        deliveryboy_id: selectedBoy?.deliveryBoys || "",
        // phone: selectedBoy?.phone || "",
        from_workshop: selectedBoy?.fromworkshop || "",
        // city: selectedBoy?.city || "",
        to_workshop: selectedBoy?.toworkshop || "",
        message: selectedBoy?.message || "",
        bike_details: selectedBoy?.bike_details || "",
        amount: selectedBoy?.amount || "",


        // driving_licence: selectedBoy?.driving_licence || "",
        // address_proof: null,
        // profile_image: null,
        // address_proof_url: selectedBoy?.address_proof_url || "",
        // profile_url: selectedBoy?.profile_url || "",
    });



    useEffect(() => {
        if (selectedBoy) {
            setFormData({
                id: selectedBoy.id || null,
                deliveryboy_id: selectedBoy.deliveryboy_id || "",
                from_workshop: selectedBoy.from_workshop || "",
                to_workshop: selectedBoy?.to_workshop || "",
                message: selectedBoy?.message || "",
                bike_details: selectedBoy?.bike_details || "",
                amount: selectedBoy?.amount || "",

            });
        }
        getLeadsData();
        getworkshopaddress();
    }, [selectedBoy]);



    const getLeadsData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/delivery-boys/list??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('Delivery Boys', response.data)

            if (response.data && response.data.data) {
                setLeads(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const getworkshopaddress = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        const url = "https://devapi.bykit.in/api/admin/get_workshopaddress??type=live"
        const payload = {
            user_id: 1
        }
        try {
            const response = await axios.post(url, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("All Bookings:", response.data);

            if (response.data?.data) {
                setworkshopaddress(response.data.data);

            }
        } catch (error) {
            console.error("Error fetching data:", error.response?.data || error.message);
        }
    };


    // Handle form field changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(`Field changed: ${name} = ${value}`);
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        setLoading(true);


        const isEditing = Boolean(selectedBoy && selectedBoy.id);


        const url = isEditing
            ? "https://devapi.bykit.in/api/admin/update_biketransfer??type=live"
            : "https://devapi.bykit.in/api/admin/add_biketransfer??type=live";

        const payload = { deliveryboy_id: formData.deliveryboy_id, from_workshop: formData.from_workshop, to_workshop: formData.to_workshop, message: formData.message, bike_details: formData.bike_details, ...(selectedBoy?.id && { id: selectedBoy.id }), amount: formData.amount }
        console.log(payload);
        try {
            const response = await axios.post(url, payload,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('manager account ', response)
            if (response.data?.status) {

                toast.success(formData.id ? "Updated successfully!" : "Added successfully!");
                setFormData({
                    id: null,
                    deliveryboy_id: "",
                    // phone: "",
                    from_workshop: "",
                    //city: "",
                    to_workshop: "",
                    message: "",
                    bike_details: "",
                    amount: "",
                    // driving_licence: "",
                    // address_proof: null,
                    // profile_image: null,
                });
                refreshManagers();
                setShowForm(false);
            }
        } catch (error) {
            console.error("Error updating status:", error.response?.data || error.message);
        }

    };

    return (
        <div className='p-3' data-aos="fade-up">
            <ToastContainer />
            <div className='managebrand_box mt-3'>
                <h4 className='dashboard_head py-4 ps-4 m-0'>{formData.id ? "Edit" : "Add"} a Bike Transfer</h4>
                <hr className='p-0 m-0' />
                <div className='p-4'>
                    <form onSubmit={handleSubmit}>
                        <div className="row mt-2">
                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label">Delivery Boy</label>
                                <select
                                    className={`form-control form-select`}
                                    name="deliveryboy_id"
                                    value={formData.deliveryboy_id}
                                    onChange={handleInputChange}>
                                    <option value="">Select a Delivery Boy</option>
                                    {leads
                                        .filter((leads) => leads.is_available && leads.status)
                                        .map((b) =>
                                        (
                                            <option key={b.id} value={b.id}>
                                                {b.name}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label">From Godown</label>
                                <select
                                    className={`form-control form-select`}
                                    value={formData.from_workshop}
                                    name="from_workshop"
                                    onChange={handleInputChange}>
                                    <option value="">Select From Godown</option>
                                    {workshopaddress.map((b) => (
                                        <option key={b.id} value={b.id}>
                                            {b.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label">To Godown</label>
                                <select
                                    className={`form-control form-select`}
                                    name="to_workshop"
                                    value={formData.to_workshop}
                                    onChange={handleInputChange}>
                                    <option value="">Select To Godown</option>
                                    {workshopaddress.map((b) => (
                                        <option key={b.id} value={b.id}>
                                            {b.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label signin_label">Bike Details</label>
                                <input
                                    type='text'
                                    name="bike_details"
                                    className='form-control'
                                    value={formData.bike_details}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label signin_label">Message</label>
                                <input
                                    type='text'
                                    name="message"
                                    className='form-control'
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-4 mt-3 col-md-6">
                                <label className="form-label signin_label">Charges</label>
                                <input
                                    type='text'
                                    name="amount"
                                    className='form-control'
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            <button type="submit" className="btn submit_btn" disabled={loading}>
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Addbikestransfer;
